import React, { useRef } from 'react';

//import { Redirect } from 'react-router-dom';
import Button from '@material-ui/core/Button';

import DialogoConfig from '../../../Resources/Config/DialogoEdit';
import { PERMISSAO_TELA_CONFIGURACOES_LISTAR } from '../../../utils/dadosTelas';
import { ProtegerPagina } from '../../VerificaPermissaoPage';

/*const Config = () => (
  <>
    <Redirect to="/config/1" />
  </>
);*/

const Config = () => {
  const refDialogo = useRef(null);

  function openDialogoConfig() {
    if (refDialogo.current) {
      refDialogo.current.handleOpen();
    }
  }

  return (
    <>
      <div
        style={{
          height: '300px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Button variant="contained" color="primary" onClick={openDialogoConfig}>
          Editar Configurações
        </Button>
      </div>
      <DialogoConfig ref={refDialogo} />
    </>
  );
};

function Wrapper() {
  return (
    <ProtegerPagina permissao={PERMISSAO_TELA_CONFIGURACOES_LISTAR}>
      <Config />
    </ProtegerPagina>
  );
}

export default Wrapper;
